// these are user facing values, and should be rendered as such
export var Dex;
(function (Dex) {
    Dex["Thor"] = "THORChain";
    Dex["Zrx"] = "0x";
    Dex["CowSwap"] = "CoW Swap";
    Dex["Maya"] = "MAYAChain";
})(Dex || (Dex = {}));
// these are user facing values, and should be rendered as such
export var TxStatus;
(function (TxStatus) {
    TxStatus["Confirmed"] = "Confirmed";
    TxStatus["Pending"] = "Pending";
    TxStatus["Failed"] = "Failed";
    TxStatus["Unknown"] = "Unknown";
})(TxStatus || (TxStatus = {}));
// these are user facing values, and should be rendered as such
export var TradeType;
(function (TradeType) {
    TradeType["Trade"] = "Trade";
    TradeType["Swap"] = "Swap";
    TradeType["Refund"] = "Refund";
})(TradeType || (TradeType = {}));
// these are user facing values, and should be rendered as such
export var TransferType;
(function (TransferType) {
    TransferType["Send"] = "Send";
    TransferType["Receive"] = "Receive";
    TransferType["Contract"] = "Contract";
})(TransferType || (TransferType = {}));
